import { Pagination } from "react-bootstrap"

export const ITEMS_PER_PAGE = 10

const AdminPagination = ({ totalItems, currentPage, onPageChange }) => {
    const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE)

    if (totalPages < 2) return null

    return (
        <Pagination className="justify-content-center">
            <Pagination.First onClick={() => onPageChange(1)} disabled={currentPage === 1} />
            <Pagination.Prev onClick={() => onPageChange(currentPage - 1)} disabled={currentPage === 1} />
            {Array.from({ length: totalPages }, (_, index) => index + 1).map(page => (
                <Pagination.Item key={page} active={page === currentPage} onClick={() => onPageChange(page)}>
                    {page}
                </Pagination.Item>
            ))}
            <Pagination.Next onClick={() => onPageChange(currentPage + 1)} disabled={currentPage === totalPages} />
            <Pagination.Last onClick={() => onPageChange(totalPages)} disabled={currentPage === totalPages} />
        </Pagination>
    )
}

export default AdminPagination
